import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import config from "../../config.json";
import Moment from "react-moment";
import { calculateIndex } from "./paginate";
import Help from "./Help";
import Pagination from "../../comman/pagination";
import PageSizeOptions from "../PageSizeOptions";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentSupportWorkflowTask,
  getStartedSupportAppData,
  getSupportBprmForm,
  getSupportTickets,
  getSupportLoading,
  loadSupportBprmForm,
  loadSupportCurrentWorkflowTask,
  loadSupportTickets,
  sendSupportTicketsMessage,
  startSupportApplication,
  supportBprmFormReceived,
} from "../../app/store/support";
import { getCurrentUser } from "../../services/authService";
import { getFieldData } from "../../services/appService";
import WorkflowElement from "../../app/components/WorkflowElement";
import useDocDownload from "../../app/hooks/useDocDownload";
import MessagingPopUpMod from "../PortalForms/MessagingPopUpMod";

const SupportPupup = (props) => {
  const { issueShowHide, handleIssueShowHide } = props;

  const [activeTab, setActiveTab] = useState("tickets");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [totalCount, setTotalCount] = useState(5);

  const [supportTickets, setSupportTicketes] = useState([]);
  const [btnProcess, setBtnProcess] = useState(false);
  const [reqCount, setReqCount] = useState(0);
  const [workflowTask, setWorkflowTask] = useState(null);
  const [helpShowHide, setHelpShowHide] = useState(false);
  const [msgObj, setMsgObj] = useState(null);
  const [msgShowHide, setMsgShowHide] = useState(false);
  const [supObj, setSupObj] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  
  const [showHelpFirst, setShowHelpFirst] = useState(false);
  const [isInitializingApp, setIsInitializingApp] = useState(false);
  const [btnProceedLoading, setBtnProceedLoading] = useState(false);
  const [isRaisingTicket, setIsRaisingTicket] = useState(false);
  const [completedTaskId, setCompletedTaskId] = useState(null);

  const supportTicketsSelector = useSelector(getSupportTickets);
  const supportTicketsLoading = useSelector(getSupportLoading);
  const supportAppStartedDataSelector = useSelector(getStartedSupportAppData);
  const currentSupportWorkflowTaskSelector = useSelector(
    getCurrentSupportWorkflowTask
  );
  const supportBprmFormSelector = useSelector(getSupportBprmForm);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (issueShowHide && currentUser?.id) {
      dispatch(loadSupportTickets(currentUser.id, pageSize, currentPage));
    }
  }, [issueShowHide, dispatch, currentUser?.id, pageSize, currentPage]);

  useEffect(() => {
    if (issueShowHide) {
      setActiveTab("tickets");
      setMsgObj(null);
      setShowHelpFirst(false);
      setIsInitializingApp(false);
      setBtnProceedLoading(false);
      setIsRaisingTicket(false);
      setCompletedTaskId(null);
    }
  }, [issueShowHide]);

  useEffect(() => {
    if (supportTicketsSelector?.data?.length > 0) {
      setSupportTicketes(supportTicketsSelector.data);
      setTotalCount(supportTicketsSelector.totalCount);
      setWfForm(null);
      setWorkflowTask(null);
      setSupObj(null);
      setMsgObj(null);
      dispatch(supportBprmFormReceived(null));
    } else if (supportTicketsSelector?.data?.length === 0) {
      setSupportTicketes([]);
      setTotalCount(0);
    }
  }, [supportTicketsSelector, dispatch]);

  const handleRunApplication = () => {
    setCompletedTaskId(null);
    setBtnProcess(true);
    setIsRaisingTicket(true);
    setIsInitializingApp(true);
    setActiveTab("add_issue");

    const newApplication = {
      workflowId: config.WorkflowIds.SupportWorkfowId,
      performerId: parseInt(currentUser.id),
      applicationId: 1,
    };
    dispatch(startSupportApplication(newApplication));
    setHelpShowHide(false);

    setTimeout(() => {
      setIsInitializingApp(false);
      setShowHelpFirst(true);
    }, 2500);
  };

  const handleCloseAndProceed = () => {
    setBtnProceedLoading(true);
    setTimeout(() => {
      setBtnProceedLoading(false);
      setShowHelpFirst(false);
    }, 2000);
  };

  const handleCancelAddIssue = () => {
    setBtnProcess(false);
    setIsRaisingTicket(false);
    setIsInitializingApp(false);
    setBtnProceedLoading(false);
    setShowHelpFirst(false);
    setCompletedTaskId(null);
    setReqCount(0);
    setWorkflowTask(null);
    setWfForm(null);
    dispatch(supportBprmFormReceived(null));
    dispatch(loadSupportTickets(currentUser.id, pageSize, 1));
    setActiveTab("tickets");
  };

  useEffect(() => {
    if (supportAppStartedDataSelector?.ciid > 0) {
      setTimeout(() => {
        dispatch(loadSupportCurrentWorkflowTask(supportAppStartedDataSelector));
        setReqCount(1);
      }, 3000);
    }
  }, [supportAppStartedDataSelector, dispatch]);

  useEffect(() => {
    if (completedTaskId && currentSupportWorkflowTaskSelector?.wiid === completedTaskId) {
      return;
    }

    if (currentSupportWorkflowTaskSelector?.formId === null && reqCount <= 5) {
      setTimeout(async () => {
        dispatch(loadSupportCurrentWorkflowTask(supportAppStartedDataSelector));
        const rqCount = reqCount + 1;
        setReqCount(rqCount);
      }, 3000);
    } else if (currentSupportWorkflowTaskSelector?.wiid > 0) {
      setWorkflowTask(currentSupportWorkflowTaskSelector);
      dispatch(loadSupportBprmForm(currentSupportWorkflowTaskSelector.formId));
    } else if (reqCount === 0 || reqCount >= 3) {
      setReqCount(0);
      setWorkflowTask(null);
      setWfForm(null);
      dispatch(loadSupportTickets(currentUser.id, pageSize, 1));
      setBtnProcess(false);
    }
  }, [currentSupportWorkflowTaskSelector, dispatch, currentUser?.id, pageSize, supportAppStartedDataSelector, reqCount, completedTaskId]);

  const handleNextTask = (btnType) => {
    if (btnType === "taskCompleted") {
      if (workflowTask) {
        setCompletedTaskId(workflowTask.wiid);
      }
      setReqCount(0);
      setWorkflowTask(null);
      setWfForm(null);
      setIsRaisingTicket(false);
      dispatch(loadSupportTickets(currentUser.id, pageSize, 1));
      setBtnProcess(false);
      setActiveTab("tickets");
    } else {
      setTimeout(() => {
        dispatch(loadSupportCurrentWorkflowTask(workflowTask));
        setReqCount(1);
      }, 3000);
    }
  };

  useEffect(() => {
    if (supportBprmFormSelector) {
      setWfForm(supportBprmFormSelector);
      setBtnProcess(false);
    }
  }, [supportBprmFormSelector]);

  const handleMessagePopup = (msg) => {
    if (!msg) {
      setMsgObj(null);
      if (activeTab === "discussion") {
        setActiveTab("tickets");
      }
    } else {
      setSupObj(msg);
      const obj = { ...msg, id: msg.commId };
      setMsgObj(obj);
      setActiveTab("discussion");
    }
  };

  const handleSelectTicketRow = (item) => {
    setSupObj(item);
    const obj = { ...item, id: item.commId };
    setMsgObj(obj);
  };

  const handleHelpShowHide = async () => {
    setHelpShowHide(!helpShowHide);
  };

  const handleRefresh = () => {
    if (currentUser?.id) {
      dispatch(loadSupportTickets(currentUser.id, pageSize, currentPage));
    }
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    const newSize = parseInt(currentTarget.value, 10) || currentTarget.value;
    setPageSize(newSize);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(newSize);
    if (currentUser?.id) {
      dispatch(loadSupportTickets(currentUser.id, newSize, 1));
    }
  };

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(
      page,
      startIndex,
      endIndex
    );
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    dispatch(loadSupportTickets(currentUser.id, pageSize, page));
  };

  const handleSendMessage = () => { };

  const handleSupportMessage = (msg, msgObj) => {
    if (msg !== "") {
      const suppportObj = {
        id: supObj.ciid,
        message: msg,
        userId: parseInt(currentUser.id),
        commId: supObj.commId || 0,
        performerId: supObj.performerId || 0,
        ciid: supObj.ciid || 0,
        wiid: supObj.wiid || 0,
        iiid: supObj.iiid || 0,
        uploadId: msgObj?.docUploadId || 0,
      };
      dispatch(sendSupportTicketsMessage(suppportObj));
    }
  };

  return (
    <>
      <Modal
        show={issueShowHide}
        onHide={handleIssueShowHide}
        dialogClassName="rt-profile-modal theme-primary"
        centered
        backdrop="static"
      >
        <style>{`
        /* Ensure the modal and backdrop are on top of sidebars/headers */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        .rt-profile-modal {
          width: min(1100px, calc(100vw - 64px)) !important;
          max-width: min(1100px, calc(100vw - 64px)) !important;
          height: auto !important;
        }
        .rt-profile-modal .modal-content {
          border-radius: 0 !important;
          box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1) !important;
          border: 1px solid #cbd5e1 !important;
          overflow: hidden !important;
          background: #ffffff !important;
          width: 100% !important;
          max-width: 100% !important;
          height: auto !important;
          max-height: calc(100vh - 60px) !important;
          display: flex !important;
          flex-direction: column !important;
          font-family: inherit !important;
        }
        .rt-profile-modal .modal-header {
          position: relative !important;
          padding: 16px 20px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
        }
        .rt-profile-modal .modal-header::before {
          display: none !important;
        }
        .rt-profile-modal .rt-header-shell {
          width: 100% !important;
        }
        .rt-profile-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 12px !important;
        }
        .rt-profile-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }
        .rt-profile-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
        }
        .rt-profile-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }
        .rt-profile-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }
        .rt-profile-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-profile-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          height: 22px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
          line-height: 1 !important;
        }
        .rt-profile-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
        }
        .rt-profile-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: none !important;
          line-height: 1 !important;
        }
        .rt-profile-modal .rt-meta-chip i,
        .rt-profile-modal .rt-meta-chip .fa {
          font-size: 11.5px !important;
          margin-right: 4px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .rt-profile-modal .rt-meta-chip i.fa-user { color: #9333ea !important; }
        .rt-profile-modal .rt-meta-chip i.fa-envelope, .rt-profile-modal .rt-meta-chip i.fa-envelope-o { color: #0284c7 !important; }
        .rt-profile-modal .rt-meta-chip i.fa-phone { color: #16a34a !important; }
        .rt-profile-modal .rt-meta-chip i.fa-hashtag { color: #d97706 !important; }
        .rt-profile-modal .rt-meta-chip i.fa-folder-open { color: #2563eb !important; }
        .rt-profile-modal .rt-meta-chip i.fa-id-badge { color: #6366f1 !important; }

        .rt-profile-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-profile-modal .rt-action-btn:hover {
          color: #dc2626 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .rt-profile-modal .modal-body {
          padding: 20px 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 200px) !important;
          overflow-y: auto !important;
        }
        .rt-profile-modal .modal-footer {
          background: #ffffff !important;
          border-top: 1px solid #e2e8f0 !important;
          padding: 14px 20px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }
        .rt-profile-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 7px 18px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          font-family: inherit !important;
        }
        .rt-profile-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 12px 16px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          margin-bottom: 16px !important;
          gap: 12px !important;
          flex-wrap: wrap !important;
        }
        .wf-header-left {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
        }
        .wf-stats-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: transparent !important;
          border: 1px solid rgba(100, 116, 139, 0.18) !important;
          color: #1e293b !important;
          border-radius: 0 !important;
          padding: 5px 12px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          letter-spacing: 0.2px !important;
        }
        .wf-stats-chip i {
          font-size: 13px !important;
          color: #1e293b !important;
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }
        .wf-loading-bar {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          height: 3px !important;
          background: linear-gradient(90deg, #171717, #737373, #171717) !important;
          background-size: 200% 100% !important;
          animation: loadingBar 1.6s ease-in-out infinite !important;
          z-index: 10 !important;
        }

        .skeleton-cell {
          display: block !important;
          height: 13px !important;
          border-radius: 0 !important;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          ) !important;
          background-size: 600px 100% !important;
          animation: shimmer 1.4s ease-in-out infinite !important;
        }
        .skeleton-cell.sk-short  { width: 40% !important; }
        .skeleton-cell.sk-medium { width: 65% !important; }
        .skeleton-cell.sk-long   { width: 85% !important; }
        .skeleton-cell.sk-full   { width: 92% !important; }
        .skeleton-row td {
          padding: 14px 16px !important;
        }

        /* ── Tabs Matching WorkflowUser ─────────────────────────────── */
        .wf-tab-bar {
          display: flex !important;
          align-items: stretch !important;
          gap: 4px !important;
          border-bottom: 2px solid #e5e5e5 !important;
          margin-bottom: 16px !important;
          padding: 8px 0 0 !important;
          position: relative !important;
          background: transparent !important;
        }

        .wf-tab-btn {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          border: none !important;
          background: transparent !important;
          padding: 9px 16px 11px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          cursor: pointer !important;
          border-radius: 0 !important;
          transition: color 0.2s ease, background 0.2s ease !important;
          outline: none !important;
          white-space: nowrap !important;
        }

        .wf-tab-btn i {
          font-size: 14px !important;
          color: currentColor !important;
          transition: color 0.2s ease !important;
        }

        .wf-tab-btn:hover {
          color: #0f172a !important;
          background: #f5f5f5 !important;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff !important;
          font-weight: 500 !important;
          background: #171717 !important;
        }

        .wf-tab-btn.active i {
          color: #ffffff !important;
        }

        .wf-tab-btn::after {
          content: "" !important;
          position: absolute !important;
          bottom: -2px !important;
          left: 0 !important;
          right: 0 !important;
          height: 2px !important;
          background: #171717 !important;
          border-radius: 0 !important;
          transform: scaleX(0) !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        .wf-tab-btn.active::after {
          transform: scaleX(1) !important;
        }

        .wf-tab-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-width: 20px !important;
          height: 20px !important;
          padding: 0 6px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          background: #f1f5f9 !important;
          color: #1e293b !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.2s ease !important;
          line-height: 1 !important;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important;
          color: #171717 !important;
          border-color: #ffffff !important;
        }

        /* ── Selected User Context Card (Matching ManageWorkflowPerformer) ── */
        .wf-assign-card {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          gap: 20px !important;
          padding: 18px 22px !important;
          background: #ffffff !important;
          border: 1px solid #d4d4d4 !important;
          border-radius: 0 !important;
          margin: 12px 0 !important;
          flex-wrap: wrap !important;
          animation: tabFadeIn 0.3s ease both !important;
        }
        .wf-assign-info {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
        }
        .wf-assign-avatar {
          width: 44px !important;
          height: 44px !important;
          border-radius: 0 !important;
          background: #171717 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: white !important;
          font-size: 16px !important;
          font-weight: 600 !important;
          flex-shrink: 0 !important;
        }
        .wf-assign-meta strong {
          display: block !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
          margin-bottom: 3px !important;
        }
        .wf-assign-meta span {
          font-size: 12px !important;
          color: #64748b !important;
          font-weight: 400 !important;
        }
        .wf-assign-actions {
          display: flex !important;
          gap: 8px !important;
          align-items: center !important;
          flex-wrap: wrap !important;
        }
        .wf-assign-actions .btn-action-search {
          height: auto !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }

        /* ── Modern Table Styles Matching WorkflowUser ─────────────────────────────── */
        .wf-table-scroll {
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          overflow-x: auto !important;
          background: #ffffff !important;
        }
        .wf-table-scroll table,
        .wf-table-scroll .wf-table {
          width: 100% !important;
          border-collapse: collapse !important;
          border: none !important;
        }
        .wf-thead {
          background: #f8fafc !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }
        .wf-thead th {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 13px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          white-space: nowrap !important;
          text-align: left !important;
        }
        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease !important;
        }
        .wf-table-row:hover {
          background: #f5f5f5 !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }
        .wf-table-row:hover td {
          color: #1e293b !important;
        }
        .wf-table-row.selected-row {
          background: #f5f5f5 !important;
          box-shadow: inset 4px 0 0 0 #171717 !important;
        }
        .wf-table-row.selected-row:hover {
          background: #eeeeee !important;
        }
        .wf-table td {
          padding: 13px 16px !important;
          font-size: 13.5px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important;
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          vertical-align: middle !important;
        }
        .wf-table tbody tr:last-child td,
        .wf-table-row.selected-row:last-child td {
          border-bottom: none !important;
        }

        .badge-capsule {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          line-height: 1 !important;
        }

                .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: "Open Sans", sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }
        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }
        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border: 1px solid #2563eb !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .btn-action-search:disabled {
          background: #ffffff !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04) !important;
          opacity: 1 !important;
        }
        .btn-action-search.btn-primary-search:disabled {
          background: #e2e8f0 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          opacity: 1 !important;
        }
        .btn-action-search.btn-danger-search {
          background: #ffffff !important;
          color: #991b1b !important;
          border: 1px solid #fca5a5 !important;
          padding: 7px 12px !important;
          box-shadow: 0 2px 5px rgba(220, 38, 38, 0.12) !important;
        }
        .btn-action-search.btn-danger-search:hover {
          background: #fff5f5 !important;
          color: #7f1d1d !important;
          border-color: #f87171 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(220, 38, 38, 0.16) !important;
        }

        /* ── Enhanced Empty / Welcome States (Square Theme) ── */
        .wf-empty-state {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 48px 24px !important;
          text-align: center !important;
          gap: 14px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          animation: tabFadeIn 0.3s ease both !important;
          min-height: 280px !important;
        }

        .wf-roles-empty-state {
          min-height: 250px !important;
          width: 100% !important;
        }

        .wf-empty-icon {
          width: 56px !important;
          height: 56px !important;
          border-radius: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 22px !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          color: #171717 !important;
          margin-bottom: 6px !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05) !important;
        }

        .wf-empty-title {
          font-size: 16px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
          margin: 0 !important;
          width: 100% !important;
          text-align: center !important;
        }

        .wf-empty-desc {
          font-size: 13.5px !important;
          font-weight: 400 !important;
          color: #64748b !important;
          margin: 0 auto !important;
          line-height: 1.6 !important;
          text-align: center !important;
          max-width: 520px !important;
        }

  `}</style>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-comments" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Customer Support Portal</span>
                      <span className="rt-modal-title-badge">
                        Support
                      </span>
                    </span>
                  </h2>
                  <div className="rt-modal-meta-row">
                    {currentUser?.name && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" style={{ color: "#9333ea", marginRight: "4px" }} />
                        <span>{currentUser.name}</span>
                      </span>
                    )}
                    {currentUser?.id && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-hashtag" aria-hidden="true" style={{ color: "#d97706", marginRight: "4px" }} />
                        <span>Reg ID: {currentUser.id}</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={handleIssueShowHide}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Page Show, Refresh, and Add Issue Button Card Section (Above Tab) */}
          {activeTab === "tickets" && !isRaisingTicket && (
            <div className="wf-card-header-bar">
              {supportTicketsLoading && <div className="wf-loading-bar" />}
              <div className="wf-header-left">
                <PageSizeOptions
                  pageSize={pageSize}
                  onChange={handlePageSizeChanged}
                />
                <span className="wf-stats-chip">
                  <i className="fa fa-ticket" aria-hidden="true" />
                  {totalCount} Total Tickets
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <button
                  type="button"
                  className="btn-action-search"
                  onClick={handleRefresh}
                  disabled={supportTicketsLoading}
                  title="Refresh support tickets"
                >
                  <i
                    className={`fa fa-refresh ${supportTicketsLoading ? "fa-spin" : ""}`}
                    aria-hidden="true"
                    style={{ marginRight: "4px" }}
                  />
                  Refresh
                </button>
                <button
                  className="btn-action-search btn-primary-search"
                  onClick={handleRunApplication}
                  disabled={btnProcess || supportTicketsLoading}
                >
                  {btnProcess ? (
                    <i className="fa fa-spinner fa-spin mr-2"></i>
                  ) : (
                    <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                  )}{" "}
                  Add Issue
                </button>
              </div>
            </div>
          )}

          {/* Tab Navigation */}
          <div className="wf-tab-bar">
            <button
              type="button"
              className={`wf-tab-btn ${activeTab === "tickets" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("tickets");
                setShowHelpFirst(false);
              }}
            >
              <i className="fa fa-list-alt" aria-hidden="true" />
              Support Tickets
              <span className="wf-tab-badge">{supportTickets.length}</span>
            </button>
            <button
              type="button"
              className={`wf-tab-btn ${activeTab === "add_issue" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("add_issue");
                // If there's no active workflow, show start ticket screen
                if (!workflowTask && !btnProcess) {
                  setShowHelpFirst(false);
                }
              }}
            >
              <i className="fa fa-plus-circle" aria-hidden="true" />
              Raise Ticket
              {(workflowTask || btnProcess || showHelpFirst) && (
                <span className="wf-tab-badge" style={{ background: "rgba(37,99,235,0.1)", color: "#1d4ed8" }}>
                  Active
                </span>
              )}
            </button>
            <button
              type="button"
              className={`wf-tab-btn ${activeTab === "discussion" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("discussion");
                setShowHelpFirst(false);
              }}
            >
              <i className="fa fa-comments" aria-hidden="true" />
              Discussion
              {msgObj && (
                <span className="wf-tab-badge" style={{ background: "rgba(37,99,235,0.1)", color: "#1d4ed8" }}>
                  Active
                </span>
              )}
            </button>
          </div>

          <div className="wf-tab-panel-container">
            {activeTab === "tickets" && (
              <div className="wf-tab-panel">
                {/* Selected Context Card (Active Ticket for discussion - Matching ManageWorkflowPerformer) */}
                {msgObj && (
                  <div className="wf-assign-card">
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        <i className="fa fa-ticket" aria-hidden="true" />
                      </div>
                      <div className="wf-assign-meta">
                        <strong>Ticket #{msgObj?.ciid}</strong>
                        <span>
                          {getFieldData(msgObj?.stateData, "customersupportportal", "Issue_Name") || "N/A"}
                          &nbsp;&bull;&nbsp;
                          <span
                            className="badge-capsule"
                            style={{
                              border: msgObj?.appApproved ? "1px solid #bbf7d0" : "1px solid #fed7aa",
                              background: msgObj?.appApproved ? "#f0fdf4" : "#fffbeb",
                              color: msgObj?.appApproved ? "#15803d" : "#c2410c",
                              padding: "2px 8px",
                              fontSize: 12,
                              gap: "4px"
                            }}
                          >
                            <i
                              className={`fa ${msgObj?.appApproved ? "fa-check" : "fa-clock-o"}`}
                              style={{ fontSize: "11px" }}
                            />
                            {msgObj?.appApproved ? "Fixed" : "Pending"}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        type="button"
                        className="btn-action-search"
                        onClick={() => setActiveTab("discussion")}
                      >
                        <i className="fa fa-comments" aria-hidden="true" /> Go to Discussion
                      </button>
                      <button
                        type="button"
                        className="btn-action-search btn-danger-search"
                        onClick={() => handleMessagePopup(null)}
                        title="Clear selection"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                )}

                <div className="row m-0">
                  <div className="col-md-12 p-0">
                    <div className="wf-table-scroll bg-white mt-2" style={{ position: "relative" }}>
                      {/* Pinned top border loading bar */}
                      {supportTicketsLoading && <div className="wf-loading-bar" />}

                      <table className="wf-table">
                        <thead className="wf-thead">
                          <tr>
                            <th>ID</th>
                            <th>Date & Time</th>
                            <th>Issue/Defect Name</th>
                            <th>Attachment</th>
                            <th>Status</th>
                            <th>Discussion</th>
                          </tr>
                        </thead>
                        <tbody>
                          {supportTicketsLoading ? (
                            Array.from({ length: pageSize }).map((_, idx) => (
                              <tr key={`skeleton-${idx}`} className="skeleton-row">
                                <td>
                                  <span className="skeleton-cell sk-short" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-medium" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-medium" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-long" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-short" />
                                </td>
                                <td>
                                  <span className="skeleton-cell sk-short" />
                                </td>
                              </tr>
                            ))
                          ) : supportTickets.length === 0 ? (
                            <tr>
                              <td colSpan={6} style={{ padding: 0 }}>
                                <div className="wf-empty-state wf-roles-empty-state">
                                  <div className="wf-empty-icon">
                                    <i className="fa fa-list-alt" />
                                  </div>
                                  <p className="wf-empty-title">
                                    No Support Tickets Found
                                  </p>
                                  <p className="wf-empty-desc">
                                    There are no support tickets raised in this system yet. Once tickets are created they'll appear here.
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            supportTickets.map((item, key) => {
                              const isSelected = msgObj?.ciid === item.ciid;
                              return (
                                <tr
                                  key={item.ciid || key}
                                  className={`wf-table-row ${isSelected ? "selected-row" : ""}`}
                                  onClick={() => handleSelectTicketRow(item)}
                                >
                                  <td>
                                    <span style={{
                                      fontWeight: 600,
                                      color: isSelected ? "#171717" : "#1e293b",
                                      fontSize: "13px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "6px"
                                    }}>
                                      {isSelected && (
                                        <i className="fa fa-check-circle" style={{ color: "#16a34a", fontSize: "13px" }} />
                                      )}
                                      #{item.ciid}
                                    </span>
                                  </td>
                                  <td>
                                    {item.startDateTime !== null && (
                                      <div className="d-flex flex-column" style={{ lineHeight: "1.3" }}>
                                        <span style={{ fontWeight: "600", color: "#1e293b", fontSize: "13px" }}>
                                          <Moment format="MMM Do YYYY">{item.startDateTime}</Moment>
                                        </span>
                                        <span style={{ color: "#64748b", fontSize: "12px", fontWeight: "400" }}>
                                          <Moment format="h:mm a">{item.startDateTime}</Moment>
                                        </span>
                                      </div>
                                    )}
                                  </td>
                                  <td style={{ fontWeight: "400", color: "#1e293b", fontSize: "13.5px" }}>
                                    {getFieldData(
                                      item.stateData,
                                      "customersupportportal",
                                      "Issue_Name"
                                    ) || "-"}
                                  </td>
                                  <td>
                                    {item.documents && item.documents.length > 0 ? (
                                      <div className="d-flex flex-wrap" style={{ gap: "6px" }}>
                                        {item.documents.map((doc) => (
                                          <span
                                            key={doc.documentUploadId || doc.documentName}
                                            className="badge-capsule"
                                            style={{
                                              cursor: "pointer",
                                              background: "#ffffff",
                                              border: "1px solid #cbd5e1",
                                              color: "#1d4ed8",
                                              gap: "4px"
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleDownloadFile(doc);
                                            }}
                                          >
                                            <i className="fa fa-paperclip" style={{ fontSize: "11px", color: "#1d4ed8" }} />
                                            {doc.documentName}
                                          </span>
                                        ))}
                                      </div>
                                    ) : (
                                      <span style={{ color: "#94a3b8", fontSize: "13px" }}>None</span>
                                    )}
                                  </td>
                                  <td>
                                    <span
                                      className="badge-capsule"
                                      style={{
                                        border: item.appApproved ? "1px solid #bbf7d0" : "1px solid #fed7aa",
                                        background: item.appApproved ? "#f0fdf4" : "#fffbeb",
                                        color: item.appApproved ? "#15803d" : "#c2410c",
                                        gap: "4px"
                                      }}
                                    >
                                      <i
                                        className={`fa ${item.appApproved ? "fa-check" : "fa-clock-o"}`}
                                        style={{ fontSize: "11px" }}
                                      />
                                      {item.appApproved ? "Fixed" : "Pending"}
                                    </span>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn-action-search"
                                      style={{
                                        background: "#ffffff",
                                        color: "#1e293b",
                                        border: "1px solid #cbd5e1",
                                        padding: "6px 12px",
                                        fontSize: "12.5px",
                                        fontWeight: "500",
                                        height: "auto",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px"
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleMessagePopup(item);
                                      }}
                                    >
                                      <i className="fa fa-comments-o" style={{ fontSize: "13px", color: "#2563eb" }} />
                                      <span>View Chat</span>
                                      <span
                                        className="badge-capsule"
                                        style={{
                                          background: "#f1f5f9",
                                          color: "#475569",
                                          border: "1px solid #e2e8f0",
                                          padding: "1px 6px",
                                          fontSize: "11px",
                                          fontWeight: "600",
                                          minWidth: "18px",
                                          height: "18px"
                                        }}
                                      >
                                        {(item.unreadCount || 0) + (item.readCount || 0)}
                                      </span>
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                      <div className="mt-3">
                        <Pagination
                          currentPage={currentPage}
                          pageSize={pageSize}
                          itemsCount={totalCount}
                          onPageChange={handlePageChange}
                          startIndex={startIndex}
                          endIndex={endIndex}
                        ></Pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "add_issue" && (
              <div className="wf-tab-panel">
                {!isRaisingTicket ? (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-ticket" aria-hidden="true" />
                    </div>
                    <h3 className="wf-empty-title">Raise a Support Ticket</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Encountered an issue or defect? Create a new support ticket and our customer support and technical team will review and resolve it.
                    </p>
                    <button
                      className="btn-action-search btn-primary-search mt-3"
                      onClick={handleRunApplication}
                    >
                      <i className="fa fa-plus mr-2" aria-hidden="true" />
                      Start New Ticket
                    </button>
                  </div>
                ) : isInitializingApp ? (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-spinner fa-spin" style={{ color: "#2563eb" }} />
                    </div>
                    <h3 className="wf-empty-title">Initializing Support Ticket...</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Please wait a moment while we set up the support session.
                    </p>
                    <button
                      className="btn-action-search btn-sm mt-3"
                      onClick={handleCancelAddIssue}
                      style={{ padding: "7px 16px", height: "auto" }}
                    >
                      Cancel & Back
                    </button>
                  </div>
                ) : showHelpFirst ? (
                  <div className="wf-tab-panel">
                    <div className="rt-support-welcome-card" style={{ background: "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)", border: "1px solid #cbd5e1", borderRadius: "12px", padding: "24px", boxShadow: "0 1px 3px rgba(15, 23, 42, 0.03)", marginBottom: "20px" }}>
                      <h3 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Welcome to our Customer Support Portal!</h3>
                      <p style={{ fontSize: "13.5px", color: "#475569", lineHeight: "1.6", marginBottom: "14px" }}>
                        In this portal we offer you an easy way to register any issue you may encounter while working and using various functions and features.
                      </p>
                      <p style={{ fontSize: "13.5px", color: "#475569", lineHeight: "1.6", marginBottom: "14px" }}>
                        Once you register an issue and submit, it will be received by our dedicated and committed customer and technical support staff who will review and provide instant fix(s), if required.
                      </p>
                      <p style={{ fontSize: "13.5px", color: "#475569", lineHeight: "1.6", marginBottom: "24px" }}>
                        Our customer and technical support staff will also update and notify you of the action taken.
                      </p>
                      <div className="support-signature">
                        <h4 style={{ margin: "0 0 4px 0", fontSize: "13.5px", fontWeight: "800", color: "#0f172a" }}>Thank you.</h4>
                        <h4 style={{ margin: "0 0 4px 0", fontSize: "13.5px", fontWeight: "800", color: "#2563eb" }}>WorkFINITY®</h4>
                        <h4 style={{ margin: "0", fontSize: "13.5px", fontWeight: "800", color: "#2563eb" }}>Customer and Technical Support</h4>
                      </div>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                      <button
                        className="btn-action-search btn-primary-search"
                        onClick={handleCloseAndProceed}
                        style={{ padding: "8px 20px" }}
                        disabled={btnProceedLoading}
                      >
                        {btnProceedLoading ? (
                          <>
                            <i className="fa fa-spinner fa-spin mr-2" />
                            Processing...
                          </>
                        ) : (
                          "Close & Proceed"
                        )}
                      </button>
                      <button
                        className="btn-action-search btn-sm"
                        onClick={handleCancelAddIssue}
                        style={{ padding: "7px 16px", height: "auto" }}
                        disabled={btnProceedLoading}
                      >
                        Cancel & Back
                      </button>
                    </div>
                  </div>
                ) : (workflowTask && wfForm) ? (
                  <div className="col-md-12 p-0">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#1e293b" }}>Active Support Form</h4>
                      <button
                        className="btn-action-search btn-danger-search btn-sm"
                        onClick={handleCancelAddIssue}
                        style={{ padding: "6px 14px", height: "auto", fontSize: "12px", display: "inline-flex", alignItems: "center", gap: "6px" }}
                      >
                        <i className="fa fa-times" /> Cancel & Back
                      </button>
                    </div>
                    <WorkflowElement
                      wfTask={workflowTask}
                      wfForm={wfForm}
                      handleNextTask={handleNextTask}
                      actionType={"workflow"}
                    />
                  </div>
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-spinner fa-spin" style={{ color: "#2563eb" }} />
                    </div>
                    <h3 className="wf-empty-title">Loading Active Support Form...</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Please wait while the active form loads.
                    </p>
                    <button
                      className="btn-action-search btn-sm mt-3"
                      onClick={handleCancelAddIssue}
                      style={{ padding: "7px 16px", height: "auto" }}
                    >
                      Cancel & Back
                    </button>
                  </div>
                )}
              </div>
            )}

            {activeTab === "discussion" && (
              <div className="wf-tab-panel">
                {msgObj ? (
                  <>
                    {/* Active Discussion Ticket Context Banner */}
                    <div className="wf-assign-card mb-3">
                      <div className="wf-assign-info">
                        <div className="wf-assign-avatar">
                          <i className="fa fa-ticket" aria-hidden="true" />
                        </div>
                        <div className="wf-assign-meta">
                          <strong>Ticket #{msgObj?.ciid} &bull; Discussion Thread</strong>
                          <span>
                            Issue: {getFieldData(msgObj?.stateData, "customersupportportal", "Issue_Name") || "N/A"}
                            &nbsp;&bull;&nbsp;
                            <span
                              className="badge-capsule"
                              style={{
                                border: msgObj?.appApproved ? "1px solid #bbf7d0" : "1px solid #fed7aa",
                                background: msgObj?.appApproved ? "#f0fdf4" : "#fffbeb",
                                color: msgObj?.appApproved ? "#15803d" : "#c2410c",
                                padding: "2px 8px",
                                fontSize: 12,
                                gap: "4px"
                              }}
                            >
                              <i
                                className={`fa ${msgObj?.appApproved ? "fa-check" : "fa-clock-o"}`}
                                style={{ fontSize: "11px" }}
                              />
                              {msgObj?.appApproved ? "Fixed" : "Pending"}
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className="wf-assign-actions">
                        <button
                          type="button"
                          className="btn-action-search"
                          onClick={() => setActiveTab("tickets")}
                        >
                          <i className="fa fa-list-alt" aria-hidden="true" /> Back to Tickets
                        </button>
                        <button
                          type="button"
                          className="btn-action-search btn-danger-search"
                          onClick={() => handleMessagePopup(null)}
                          title="Close Discussion"
                        >
                          ✕
                        </button>
                      </div>
                    </div>

                    <MessagingPopUpMod
                      msgShowHide={true}
                      message={msgObj}
                      handleMsgModalShowHide={() => handleMessagePopup(null)}
                      handleSendMessage={handleSendMessage}
                      handleSupportMessage={handleSupportMessage}
                      isInline={true}
                    />
                  </>
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-comments-o" aria-hidden="true" />
                    </div>
                    <h3 className="wf-empty-title">No Active Discussion Selected</h3>
                    <p className="wf-empty-desc" style={{ maxWidth: "500px" }}>
                      Please select a ticket from the <strong>Support Tickets</strong> tab and click <strong>"View Chat"</strong> to view messages, send attachments, or write replies.
                    </p>
                    <button
                      className="btn-action-search btn-primary-search mt-3"
                      onClick={() => setActiveTab("tickets")}
                    >
                      <i className="fa fa-list-alt mr-2" aria-hidden="true" />
                      View Support Tickets
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleIssueShowHide}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Help
        helpShowHide={helpShowHide}
        handleHelpShowHide={handleHelpShowHide}
        module="Support"
      ></Help>
    </>
  );
};

export default SupportPupup;
